<!--
 * @Author: bhl
 * @Date: 2022-11-22 15:52:22
 * @LastEditTime: 2022-11-22 15:52:22
 * @LastEditors: bhl
 * @Description: 应用商店
-->
<template>
  <div class="cooperation">
    <el-row style="display: flex; flex-flow: wrap">
      <el-col
        :span="8"
        v-for="(item, index) in dataList"
        :key="index"
        @click.native="routerHandle"
      >
        <img :src="item.logo" alt="0Pic" style="width: 68px; height: 68px" />
        <div class="RightBorder" style="flex: 1 1 0%">
          <font class="sloganTitleStyle">{{ item.slogan }}</font>
          <ul class="el-rate" style="font-size: 18px; margin-left: -2px">
            <i class="el-icon-star-on" style="color: #fadb14"></i>
            <i class="el-icon-star-on" style="color: #fadb14"></i>
            <i class="el-icon-star-on" style="color: #fadb14"></i>
            <i class="el-icon-star-on" style="color: #fadb14"></i>
            <i class="el-icon-star-on" style="color: #fadb14"></i>
          </ul>
          <div class="sloganAbstractDiv">
            <font
              class="sloganAbstract"
              style="-webkit-box-orient: vertical; color: rgb(153, 153, 153)"
            >
              {{ item.content }}
            </font>
          </div>
          <div style="height: 2px">&nbsp;</div>
          <div>
            <span v-for="(vitem, vindex) in item.tags" :key="vindex">
              <font class="tags-abstract">
                {{ vitem }}
              </font>
              &nbsp;&nbsp;
            </span>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getAccessToken } from '@/utils/userInfo'
export default {
  data () {
    return {
      dataList: [
        {
          logo: 'https://store.supos.com/galileo/2e794c4cb9654b1bacc5703ad80ead50.jpg',
          slogan: '汽配设备管理',
          content: '为汽配行业打造，支持设备点检、维修、保养、盘点等操作',
          tags: ['离散制造', '汽配', '设备管理']
        },
        {
          logo: 'https://store.supos.com/galileo/25d163a7cf924bf29fefe4a4a24a5a9d.jpg',
          slogan: '物料管理',
          content:
            '对生产过程中涉及的物料进行统一的管理、包括物料唯一编码、物料仓储、生产、工艺属性等',
          tags: ['离散制造', 'MES']
        },
        {
          logo: 'https://store.supos.com/galileo/12952885cc224cb79e42cfc14527c2b7.jpg',
          slogan: '出入库管理',
          content: '实现企业物料出入库的信息化管理，消除企业出入库及库存糊涂账',
          tags: ['离散制造', '生产制造', '仓库管理']
        },
        {
          logo: 'https://store.supos.com/galileo/db3efac0f4424c37832139c04c99fd94.jpg',
          slogan: '仓储库存管理',
          content: '一目了然展示企业的库存现有量'
        },
        {
          logo: 'https://store.supos.com/galileo/f7b4665c6d0b418aaf954aa7b530024e.jpg',
          slogan: '设备台账管理',
          content:
            '实现设备的全生命周期信息化管理，一目了然展示企业设备的资产现有量及状态'
        },
        {
          logo: 'https://store.supos.com/galileo/62d465f377e247abb1340873097da9f1.jpg',
          slogan: '设备基础配置',
          content:
            '支持企业自定义设备的生命周期状态、设备分类类别、设备故障库，是设备信息化管理的基础支撑数据'
        },
        {
          logo: 'https://store.supos.com/galileo/d088afb7adb943cabd9a2c1c32498d80.jpg',
          slogan: '供应商管理',
          content:
            '实现供应商信息化管理，是采购管理过程供应商管理的基础支撑数据',
          tags: ['离散制造', '生产制造']
        },
        {
          logo: 'https://store.supos.com/galileo/273e3cf7fd4b46e2a965552850daf9bb.jpg',
          slogan: '仓储配置',
          content: '实现仓库、库位信息化管理，是仓储管理的基础支撑数据',
          tags: ['离散制造', '生产制造', '仓库管理']
        },
        {
          logo: 'https://store.supos.com/galileo/5d917f51a5e64c3a9d3a80a69e0cf18b.jpg',
          slogan: '生产工单管理',
          content:
            '实现生产工单信息化管理，帮助企业更细维度分解、下达生产任务、跟踪生产执行过程，一目了然掌控车间级生产状况',
          tags: ['生产制造', '离散制造', 'MES']
        },
        {
          logo: 'https://store.supos.com/galileo/ceb3cbc08def4ecdb99075a97e23b9fb.jpg',
          slogan: '工厂模型管理',
          content: '实现客户工厂、车间、产线、工站等组织节点的系统化管理',
          tags: ['离散制造', '智能制造', 'MES']
        },
        {
          logo: 'https://store.supos.com/galileo/ad0e194d9c844abf867c0a54a1ea9deb.jpg',
          slogan: '生产订单管理',
          content:
            '实现生产订单信息化管理，帮助企业跟踪当前生产订单计划及生产进度',
          tags: ['MES', '生产制造', '离散制造']
        },
        {
          logo: 'https://store.supos.com/galileo/dd648dd40ff14b7da4060abe36c81c59.jpg',
          slogan: '备件管理',
          content:
            '实现备件信息化管理，规范备件管理、领用过程，准确跟踪备件数量，为企业保持合理备件库存提供精准数据支撑',
          tags: ['离散制造', '生产制造', '设备管理']
        },
        {
          logo: 'https://store.supos.com/galileo/88551b6170724e86a62dbdb7b67f75ec.jpg',
          slogan: '设备检维修管理',
          content:
            '线上记录设备维修过程，形成企业设备维修档案，有助于企业规范维修作业行为、主动分析发现设备故障，提高设备利用率'
        },
        {
          logo: 'https://store.supos.com/galileo/c32afc57a44145de833935b012c144b1.jpg',
          slogan: '装置工厂模型',
          content:
            '实现客户工厂、装置、工段等组织节点的系统化管理，为各领域业务APP提供基础数据支撑。',
          tags: ['生产制造', '石化', '化工']
        },
        {
          logo: 'https://store.supos.com/galileo/e2fff37702cd464eb00db89178329542.jpg',
          slogan: 'APC投用率',
          content:
            '企业管理者可以实时监控APC运行情况，从而提升装置运行稳定性和安全性，保证产品质量的均匀性，提高目标产品收率。',
          tags: ['石化', '生产制造', '过程管控']
        }
      ]
    }
  },
  mounted () {},
  methods: {
    routerHandle () {
      if (!getAccessToken()) {
        this.$router.push({
          name: 'login'
        })
      } else {
        // 判断是否属于单点登录-初始化用户,是则跳蓝卓页面
        this.$http.get(`/front/sys/suposUser/ssoInfo`).then(({ data: res }) => {
          if (res.data && res.data.enabled) {
            window.open(
              `${res.data.ssoUrl}?source=${
                res.data.params.source
              }&redirectUrl=${
                res.data.params.redirectUrl
              }&token=${getAccessToken()}`
            )
          } else {
            this.$message.warning('该账号暂无应用商店查看权限')
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.cooperation {
  width: 1190px;
  margin: 10px auto;
  background: #fff;
  padding: 20px 0;

  .el-row {
    .el-col {
      width: 390px;
      height: 180px;
      background: #ffffff;
      border-radius: 2px;
      display: flex;
      border: 1px solid transparent;
      position: relative;
      padding: 0 32px 0 0;
      flex: 0 0 33.33333333%;
      max-width: 33.33333333%;
      cursor: pointer;

      &:hover {
        z-index: 1;
        background: #ffffff;
        border: 1px solid #ececec;
        box-shadow: 0 4px 10px 0 #eaedf3;
        border-radius: 2px;
      }

      img {
        width: 68px;
        height: 68px;
        border-radius: 12px;
        margin: 18px 28px 80px 20px;
      }

      .RightBorder {
        border-top: 1px solid #ededed;

        .sloganTitleStyle {
          font-size: 18px;
          color: #000000;
          display: block;
          margin-top: 22px;
        }

        .el-rate {
        }

        .sloganAbstractDiv {
          height: 66px;

          .sloganAbstract {
            font-family: MicrosoftYaHei;
            font-size: 13px;
            color: #1a1a1a;
            line-height: 23px;
            width: 240px;
            margin-top: 6px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            overflow: hidden;
          }
        }

        .tags-abstract {
          font-size: 11px;
          color: #6081a1;
          margin-bottom: 6px;
          line-height: 23px;
          overflow: hidden;
          margin-top: 5px;
        }
      }
    }
  }
}
</style>
